<template>
  <v-autocomplete
    color="primary"
    v-model="payTypesSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="payTypes"
    :loading="payTypesLoading"
    :search-input.sync="payTypesSearch"
    item-text="value"
    item-value="key"
    :label="noLabel ? '' : $t('billRecords.Fields.pay_type')"
    return-object
  ></v-autocomplete>
</template>

<script>
import Receipt from "@/api/receipt";

export default {
  name: "SearcherPayTypes",

  props: { value: Array, noLabel: Boolean },

  computed: {},

  data: () => ({
    payTypes: [],
    payTypesLoading: false,
    payTypesSearch: "",
    payTypesSelected: [],
  }),

  mounted() {
    this.payTypesLoading = true;
    Receipt.getAvailablePayTypes()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            Object.entries(response.data.pay_types).forEach((type) => {
              this.payTypes.push({
                key:type[0],
                value:type[1]
              })
            })
          }
          this.payTypesLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.payTypesLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.payTypesSelected = this.value;
      },
    },
    payTypesSelected: {
      handler() {
        this.$emit("input", this.payTypesSelected);
      },
    },
  },
};
</script>
